import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AbsoluteWebUrlService {
  getBaseUrl(): string {
    return environment.webUrl;
  }
}